<template>
  <div class="stock-list">
    <button
      v-if="showDeleteButton"
      class="delete-selected-btn"
      @click="deleteSelectedStocks"
    >
      刪除選擇項目
    </button>

    <table class="stock-table">
      <thead>
        <tr>
          <th></th>
          <th
            @click="sortBy('stock_name')"
            @touchend="handleTouchSort($event, 'stock_no')"
            @touchstart="startTouchSort($event)"
            @touchmove="moveTouchSort($event)"
          >
            編號-名稱
          </th>
          <th
            @click="sortBy('trend')"
            @touchend="handleTouchSort($event, 'trend')"
            @touchstart="startTouchSort($event)"
            @touchmove="moveTouchSort($event)"
          >
            5個周期趨勢預測
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(stock, index) in stocks"
          :key="index"
          class="swipe-row"
          @touchstart="startTouch($event, index)"
          @touchmove="moveTouch($event, index)"
          @touchend="endTouch($event, index)"
          :class="{ swiped: swipedIndex === index }"
        >
          <td class="checkbox-cell">
            <label class="checkbox-wrapper">
              <input
                type="checkbox"
                :value="index"
                v-model="selectedStocks"
                class="touch-checkbox"
                :aria-label="'Select ' + stock.stock_name"
              />
            </label>
          </td>

          <td class="row-wrapper">
            <div class="row-content" style="justify-content: center">
              <span>{{ stock.stock_no }}-{{ stock.stock_name }}</span>
            </div>
          </td>

          <td>
            <div class="row-content">
              <span style="white-space: nowrap">
                <span
                  v-for="(trend, day) in stock.trend"
                  :key="day"
                  :class="getTrendClass(trend)"
                >
                  {{ trend + "\uFE0E" }}
                </span>
                <span class="trend-count">({{ stock.trend_count }})</span>
                <br />
                <span
                  :class="
                    stock.last_stock_price > stock.previous_stock_price
                      ? 'price-up'
                      : stock.last_stock_price < stock.previous_stock_price
                      ? 'price-down'
                      : 'price-flat'
                  "
                >
                  {{ stock.previous_stock_price }} →
                  {{ stock.last_stock_price }}
                </span>
              </span>
            </div>
          </td>

          <td class="row-wrapper action-cell">
            <button
              v-if="swipedIndex === index"
              class="delete-btn"
              @click.stop="deleteStock(index)"
              @touchstart.stop
              @touchend.stop
            >
              移除
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <stock-notification
      :upToDownStocks="upToDownStocks"
      :firstUpStocks="firstUpStocks"
    />
  </div>
</template>

<script>
import StockNotification from "@/components/StockNotification.vue";
import { mapActions } from "vuex";

export default {
  name: "StockList",
  components: {
    StockNotification,
  },
  props: {
    msg: { type: String, default: "Stock List" },
  },
  data() {
    return {
      stocks: [],
      upToDownStocks: [],
      firstUpStocks: [],
      sortKey: "",
      sortOrder: 1,
      touchStartX: 0,
      touchEndX: 0,
      swipedIndex: null,
      selectedStocks: [],
    };
  },
  computed: {
    showDeleteButton() {
      return this.selectedStocks.length > 0;
    },
  },
  methods: {
    ...mapActions(["fetchStocks", "removeStock"]),
    getTrendClass(trend) {
      return {
        "trend-up": trend === "↗",
        "trend-down": trend === "↘",
        "trend-flat": trend === "→",
      };
    },
    assignStock(stocks) {
      this.upToDownStocks = stocks.filter((stock) => stock.trend_up_to_down);
      this.firstUpStocks = stocks.filter((stock) => stock.trend_first_up);
      this.stocks = stocks;
    },
    async deleteSelectedStocks() {
      const selectedStockNos = this.selectedStocks.map(
        (index) => this.stocks[index].stock_no
      );
      try {
        await this.removeStock({ stocks: selectedStockNos });
        this.stocks = this.stocks.filter(
          (_, index) => !this.selectedStocks.includes(index)
        );
        this.selectedStocks = [];
      } catch (err) {
        console.error("Failed to delete selected stocks:", err);
      }
    },
    async refresh() {
      const stocks = await this.fetchStocks();
      this.assignStock(stocks);
    },
    startTouch(e) {
      this.touchStartX = e.changedTouches[0].screenX;
      this.swipedIndex = null;
    },
    moveTouch(e) {
      this.touchEndX = e.changedTouches[0].screenX;
    },
    endTouch(e, index) {
      const touchEndX = e.changedTouches[0].screenX;
      const diff = this.touchStartX - touchEndX;
      if (diff > 50) {
        this.swipedIndex = index;
      } else {
        this.swipedIndex = null;
      }
    },
    async deleteStock(index) {
      const stock = this.stocks[index];
      const stockNo = stock.stock_no;
      try {
        await this.removeStock({ stocks: [stockNo] });
        this.stocks.splice(index, 1);
        this.swipedIndex = null;
      } catch (err) {
        console.error("Failed to delete stock:", err);
      }
    },
    sortBy(key) {
      if (this.sortKey == key) {
        this.sortOrder = -this.sortOrder;
      } else {
        this.sortKey = key;
        this.sortOrder = 1;
      }

      this.stocks.sort((a, b) => {
        let valueA = a[key];
        let valueB = b[key];

        if (key == "trend") {
          valueA = a.trend.join("");
          valueB = b.trend.join("");
        }

        if (valueA < valueB) return -1 * this.sortOrder;
        if (valueA > valueB) return 1 * this.sortOrder;
        return 0;
      });
    },
    startTouchSort(event) {
      this.touchSortStartX = event.touches[0].clientX;
      this.touchSortMoved = false;
    },
    moveTouchSort(event) {
      if (this.touchSortStartX !== null) {
        const touchX = event.touches[0].clientX;
        const deltaX = touchX - this.touchSortStartX;
        if (Math.abs(deltaX) > 10) {
          this.touchSortMoved = true;
        }
      }
    },
    handleTouchSort(event, key) {
      event.preventDefault();
      if (!this.touchSortMoved) {
        this.sortBy(key);
      }
      this.touchSortStartX = null;
      this.touchSortMoved = false;
    },
  },
  async created() {
    const stocks = await this.fetchStocks();
    this.assignStock(stocks);
  },
};
</script>

<style lang="scss" scoped>
$primary: #4dba87;
$down: #28a745;
$up: #dc3545;
$flat: #6c757d;

.stock-list {
  text-align: center;
}

h3 {
  color: $primary;
}

.stock-table {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  border-collapse: collapse;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

th,
td {
  padding: 12px;
  border-bottom: 1px solid lighten($primary, 30%);
}

th {
  background: $primary;
  color: white;
  text-transform: uppercase;
  font-size: 16px;
}

td {
  font-size: 16px;
}

.trend-count {
  color: $primary;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1.1em;
  font-weight: 600;
}

.trend-up {
  color: $up;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1.2em;
  font-weight: 900;
  margin-right: 5px;
  display: inline-block;
  transform: scale(1.2);
  text-shadow: 0 0 1px currentColor;
}

.trend-down {
  color: $down;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1.2em;
  font-weight: 900;
  margin-right: 5px;
  display: inline-block;
  transform: scale(1.2);
  text-shadow: 0 0 1px currentColor;
}

.trend-flat {
  color: $flat;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1.2em;
  font-weight: 900;
  margin-right: 5px;
  display: inline-block;
  transform: scale(1.2);
  text-shadow: 0 0 1px currentColor;
}

span:last-child {
  margin-right: 0;
}

.swipe-row {
  position: relative;
  overflow: hidden;
}

.row-wrapper {
  padding: 0;
  position: relative;
}

.row-content {
  display: flex;
  justify-content: space-between;
  background: white;
  transition: transform 0.3s ease;
  padding: 12px;
}

.swipe-row.swiped .row-content {
  transform: translateX(-70px);
}

.delete-btn {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 70px;
  background-color: #dc3545;
  color: white;
  border: none;
  font-size: 1.1em;
  font-weight: bold;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0;
}

.selected {
  background-color: #f5f5f5;
}

.delete-selected-btn {
  margin: 10px 0;
  padding: 10px 20px;
  background-color: #dc3545;
  color: white;
  border: none;
  font-size: 1em;
  font-weight: bold;
  cursor: pointer;
  text-transform: uppercase;
}

.price-up {
  color: $up;
  font-weight: 600;
}

.price-down {
  color: $down;
  font-weight: 600;
}

.price-flat {
  color: $flat;
  font-weight: 600;
}

span:last-child {
  margin-right: 0;
}

.checkbox-cell {
  width: 60px;
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
}

.touch-checkbox {
  width: 28px;
  height: 28px;
  cursor: pointer;
  accent-color: $primary;
}

.row-wrapper.action-cell .row-content {
  padding: 0;
}
</style>
